<template>
  <div class="partner-logos">
    <h1>Partner logos</h1>
    <div class="wrap">
      <div class="top">
        <h2>Enable/Disable partner logos in footer area</h2>
        <a-switch :checked="isChecked" @change="onChange" />
      </div>
      <div class="bottom">
        <p>This button moves you to the top of the page when you click it.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isChecked: {
      type: Boolean,
    },
  },
  methods: {
    onChange(checked) {
      this.$emit("togglePartnerLogos", checked ? 1 : 0);
    },
  },
};
</script>

<style scoped lang='scss'>
.partner-logos {
  h1 {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 21px;
    color: #001529;
    border-bottom: 1px solid #cbcbe4;
    padding: 25px 0;
  }
  .wrap {
    .top {
      max-width: 500px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 30px 0 16px 0;
      h2 {
        margin: 0;
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        color: #001529;
      }
    }
  }
}
</style>